import React from 'react';
import type { SxProps, Theme } from '@mui/material';
import { ResourcesPreviewModule } from '../../article/resources-preview-module';
import { HomepageModuleWrapper } from '../homepage-module-wrapper';
import { BREAKPOINT } from '../../../../component_library/utils/breakpoints';
import type { IArticlesPreviewModuleData } from '../../../../dotcms/dotcms-models/resources/dotcms-module-articles-preview';
import { DataElementId } from '../../../../constants/data-element-tracking-ids';
import { Page } from '../../../../app/page-url-path';
import { useGetRouteToIssuerPage } from '../../../../app/get-route-to-page';
import { ButtonVariant } from '../../../../component_library/components/Button';
import { useGetPageConditionRequirementResults } from '../../../../app/pages-requiring-condition';
import { areRelatedResourcesEmpty } from '../../../../dotcms/dotcms-models/resources/related-resources-helpers';

interface IProps {
  data: IArticlesPreviewModuleData;
  muiTheme: Theme;
}

const RichResourcesModule: React.FC<IProps> = ({ data, muiTheme }) => {
  const {
    header, description, articleLink, button,
  } = data;

  const rootStyles: SxProps<Theme> = {
    textAlign: 'center',
    '& .articles-preview-cards-wrapper': {
      [muiTheme.breakpoints.down('tabletMini')]: {
        justifyContent: 'center',
      },
    },
    '& .articles-preview-cards-wrapper:not(:first-of-type)': {
      [muiTheme.breakpoints.down('tabletMini')]: {
        paddingTop: '40px',
      },
    },
  };

  const buttonUrl = useGetRouteToIssuerPage(Page.RESOURCE_LIBRARY);
  const isResourcePageAvailable =
    useGetPageConditionRequirementResults()[Page.RESOURCE_LIBRARY];

  if (!isResourcePageAvailable || areRelatedResourcesEmpty(data)) {
    return null;
  }

  return (
    <HomepageModuleWrapper
      dataComponentName="RichResourcesModule"
      sx={rootStyles}
    >
      <ResourcesPreviewModule
        headlineHtml={header}
        noteHtml={description}
        resources={data}
        maxCountOfResources={{
          [BREAKPOINT.DESKTOP]: 3,
          [BREAKPOINT.TABLET_MINI]: 2,
        }}
        articleLink={articleLink}
        button={
          button
            ? {
              dataElementId: DataElementId.ARTICLES_PREVIEW_VIEW_ALL,
              buttonCtaText: button.text,
              buttonDestinationLink: buttonUrl ?? button.url,
              buttonVariant: ButtonVariant.SECONDARY,
            }
            : undefined
        }
      />
    </HomepageModuleWrapper>
  );
};

export default RichResourcesModule;
